import { Outlet } from "react-router-dom";
import { Header } from "../components/navigation/Header";
import { Footer } from "../components/navigation/Footer";
import { ToastContainer } from "react-toastify";
import { useQuery } from "@tanstack/react-query";
import { self } from "../http/auth";
import { useAuthStore } from "../store/authStore";
import { useEffect } from "react";

export const MainLayout = () => {
  const { setUser } = useAuthStore();
  const { data, isLoading } = useQuery({
    queryKey: ["self"],
    queryFn: self,
    retry: 0,
    refetchOnWindowFocus: false,
  });
  useEffect(() => {
    if (data) {
      const user = data.data.user;
      console.log("DATA : ", data);
      setUser(user);
    }
  }, [data]);
  if (isLoading) {
    return (
      <div className="flex h-screen w-full justify-center items-center bg-flyers-black">
        <div className="loader"></div>
      </div>
    );
  }
  return (
    <div className="bg-flyers-black min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <ToastContainer
        theme="dark"
        autoClose={2000}
        toastStyle={{ backgroundColor: "#1A1A1A", color: "#FFFFFF" }}
      />
    </div>
  );
};
